import {
  BUFFER_DAYS, EXPIRY_DAYS, HOTEL_CREDIT_MODAL_COOKIE, MAX_DISMISS_COUNT,
} from '../constants/cookiesConstants';

export const getCookieOptions = () => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + EXPIRY_DAYS);
  return {
    domain: 'americanexpress.com',
    path: '/',
    expires: expiryDate,
  };
};

export const updateCookie = (cookieValue, cookieKey) => {
  const now = new Date();
  const updatedCookie = Object.assign([], cookieValue);
  const cookieIndex = updatedCookie.findIndex((cookie) => cookie.key === cookieKey);
  if (cookieIndex !== undefined && cookieIndex === -1) {
    updatedCookie.push({ key: cookieKey, count: 1, date: now });
  } else {
    updatedCookie[cookieIndex].count += 1;
    updatedCookie[cookieIndex].date = now;
  }
  return updatedCookie;
};

export const setModalCookies = (cookies, accountToken) => {
  const cookieList = cookies.get(HOTEL_CREDIT_MODAL_COOKIE);
  const updatedCookie = updateCookie(cookieList, accountToken);
  cookies.set(
    HOTEL_CREDIT_MODAL_COOKIE, updatedCookie, getCookieOptions());
};

export const isModalDismissedInLastXDays = (modalCookie) => {
  const today = new Date();
  const nextTimeModalCanBeShown = new Date(modalCookie.date);
  nextTimeModalCanBeShown.setDate(nextTimeModalCanBeShown.getDate() + BUFFER_DAYS);
  return today.getTime() < nextTimeModalCanBeShown.getTime();
};

export const isModalDismissed = (cookieList, accountToken) => {
  if (Array.isArray(cookieList)) {
    const modalCookie = cookieList.find((cookie) => cookie.key === accountToken);
    if (!modalCookie || !modalCookie?.count || !modalCookie?.date) {
      return false;
    }
    return isModalDismissedInLastXDays(modalCookie)
      || modalCookie?.count >= MAX_DISMISS_COUNT;
  }
  return false;
};
